<template>
  <div v-if="!uid">
    <div class="intro">
      <div class="headerImg">
        <img src="../assets/gymbook.png" height="250" width="250" />
      </div>
      <div class="loginButton">
        <button type="button" class="btn btn-primary" @click="login()">Log In</button>
      </div>
    </div>
  </div>
</template>
<script>
import { dbConnection } from '@/firestore/firestore';
import { provideToast, useToast } from 'vue-toastification';
export default {
  name: 'LoginPage',
  components: {},
  setup() {
    provideToast({ maxToasts: 5 });
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      dbConnection,
      initializing: true,
    };
  },
  computed: {},
  methods: {
    async login() {
      await this.dbConnection.login();
      this.$router.push({ name: 'home' });
    },
    logout() {
      this.dbConnection.logout();
      this.uid = null;
    },
    goto(where) {
      this.$router.push({ name: where, state: { uid: this.uid } });
      this.menuOpen = false;
    },
  },
};
</script>
